import { createAction } from '../helpers';

export const setFeedbackItemsFilter = createAction('SET_FEEDBACK_ITEMS_FILTER');
